import dayjs from "dayjs";
export const GetDefaultEndDate = () => {
  return {
    $D: dayjs().date(),
    $H: dayjs().hour(),
    $L: "en",
    $M: dayjs().month(),
    $W: dayjs().week(),
    $d: dayjs().format("ddd MMM DD YYYY 00:00:00 [GMT] (India Standard Time)"),
    $isDayjsObject: true,
    $m: 0,
    $ms: 0,
    $s: 0,
    $u: null,
    $x: {},
    $y: dayjs().year(),
  };
};

export const getTabIndex = {
  "/sno": 1,
  "/dom": 1,
  "/rr": 1,
  "/dp": 2,
  "/do": 2,
  "/dip": 3,
  "/cp": 3,
  "/nps": 3,
  "/action/nps": 3,
  "/action/STCP-RDP": 3,
  "/action/LTCP-RDP": 3,
  "/fgs": 4,
  "/poos": 4,
  "/action/fgs": 4,
  "/ff": 5,
  "/action/ff": 5,
  "/ds": 5,
  "/action/DC": 5,
  "/action/3LP": 5,
  "/action/CONFIG": 5,
  "/slp": 6,
  "/iof": 6,
  "/iofpb": 6,
  "/erm": 6,
  "/ua": 7,
  "/mrs": 7,
};
